import HttpServices from 'src/services/httpService';
import { userModuleURL } from 'src/services/urlService';
import { CommonHelper } from 'src/utils/commonHelper';

const GATEWAY_HTTP_URL = (process.env.REACT_APP_WEBSOCKET_URL || `${window.location.origin}`).replace(/\/+$/, '');
const LIVE_CHAT_NOTIFICATION_PROMPT_KEY = 'live_chat_notification_prompt_status';
export const GATEWAY_WS_URL = GATEWAY_HTTP_URL.replace(/^http/i, 'ws');

export const getLiveChatWebSocketURL = () => {
  try {
    const baseURL = new URL(GATEWAY_HTTP_URL, window.location.origin);
    baseURL.protocol = baseURL.protocol === 'https:' ? 'wss:' : 'ws:';
    baseURL.pathname = `${baseURL.pathname.replace(/\/+$/, '')}/ws/live-chat`;
    baseURL.search = '';
    baseURL.hash = '';
    return baseURL.toString();
  } catch (_error) {
    return `${GATEWAY_WS_URL}/ws/live-chat`;
  }
};

export const hasLiveChatManagePermission = () =>
  CommonHelper.CheckForPermissionAvailableForUser(CommonHelper.PermissionList.LIVE_CHAT_MANAGE);

export const getLiveChatAgentContext = () => {
  const userInfo = CommonHelper.GetBrandInfoFromLocalStorage('user_details') || {};
  const brandDetails = CommonHelper.GetBrandInfoFromLocalStorage('brand_details') || [];
  const currentBrandId =
    CommonHelper.GetCurrentBrandId() || brandDetails?.[0]?.brand_id || brandDetails?.[0]?.id || 0;
  const orgId =
    CommonHelper.GetBrandInfoFromLocalStorage('org_id') ||
    brandDetails?.[0]?.org_id ||
    brandDetails?.[0]?.organization_id ||
    0;
  const userId =
    userInfo.user_id ||
    userInfo.id ||
    CommonHelper.GetBrandInfoFromLocalStorage('user_id') ||
    CommonHelper.GetBrandInfoFromLocalStorage('id') ||
    0;

  return {
    userId: Number(userId || 0),
    brandId: Number(currentBrandId || 0),
    orgId: Number(orgId || 0),
  };
};

export const getLiveChatNotificationSessionId = () => {
  const existingSessionId = localStorage.getItem('live_chat_notification_session');
  if (existingSessionId) {
    return existingSessionId;
  }
  const nextSessionId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  localStorage.setItem('live_chat_notification_session', nextSessionId);
  return nextSessionId;
};

export const getLiveChatNotificationPromptStatus = () =>
  localStorage.getItem(LIVE_CHAT_NOTIFICATION_PROMPT_KEY) || '';

export const setLiveChatNotificationPromptStatus = (status) => {
  if (!status) {
    localStorage.removeItem(LIVE_CHAT_NOTIFICATION_PROMPT_KEY);
    return;
  }
  localStorage.setItem(LIVE_CHAT_NOTIFICATION_PROMPT_KEY, status);
};

export const shouldAskLiveChatNotificationPermission = () => {
  if (typeof Notification === 'undefined') return false;
  if (Notification.permission !== 'default') return false;
  return getLiveChatNotificationPromptStatus() !== 'dismissed';
};

const getLiveChatNotificationSyncKey = (body) =>
  JSON.stringify({
    session_id: body.session_id,
    endpoint: body.endpoint,
    permission: body.subscription_json?.permission,
    is_enabled: body.is_enabled,
  });

export const saveLiveChatNotificationSubscription = (isEnabled, permissionValue, options = {}) => {
  const body = {
    session_id: getLiveChatNotificationSessionId(),
    endpoint: window.location.origin,
    subscription_json: {
      permission: permissionValue,
      user_agent: navigator.userAgent,
    },
    is_enabled: isEnabled,
  };
  const syncKey = getLiveChatNotificationSyncKey(body);
  const storageKey = 'live_chat_notification_subscription_sync_key';

  if (!options.force && localStorage.getItem(storageKey) === syncKey) {
    return;
  }

  HttpServices.Post({
    url: userModuleURL.liveChatNotificationSubscriptions,
    body,
    successCallback: () => {
      localStorage.setItem(storageKey, syncKey);
    },
    failureCallback: () => {},
  });
};

export const requestLiveChatBrowserNotificationPermission = async () => {
  if (typeof Notification === 'undefined') {
    return 'denied';
  }

  let permission = Notification.permission;
  if (permission === 'default') {
    try {
      permission = await Notification.requestPermission();
    } catch (error) {
      permission = Notification.permission;
    }
  }

  setLiveChatNotificationPromptStatus(permission === 'granted' ? 'accepted' : 'dismissed');
  saveLiveChatNotificationSubscription(permission === 'granted', permission, { force: true });
  return permission;
};

export const showLiveChatBrowserNotification = (title, body, options = {}) => {
 
  //   console.log('Notification check', {
  //   permission: typeof Notification !== 'undefined' ? Notification.permission : 'no-api',
  //   visibility: document.visibilityState,
  //   isSecureContext,
  //   title,
  //   body,
  // });
  if (typeof Notification === 'undefined') return;
  if (Notification.permission !== 'granted') return;
  if (!options.force && document.visibilityState === 'visible') return;

  try {
    const notification = new Notification(title || 'Live Chat', {
      body: body || 'New message received',
      tag: 'live-chat',
      requireInteraction: true,
      renotify: true,
      data: {
        url: options.url || '',
      },
    });

    notification.onclick = () => {
      window.focus();
      if (options.url) {
        window.location.assign(options.url);
      }
      notification.close();
    };
  } catch (e) {
    console.error('Browser notification failed:', e);
  }
};
